import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';
import FeaturedList from './FeaturedList';

const SeriesInt = ({moveItem, addItem, saveIndividual, showUpdateBtn, removeItem, cobrandId, model}) => {
  const [{ data, loading }] = useAxios({ url: `internal/cobrand/series`, method: "get" });
    return (
        <FeaturedList 
        moveItem={(index, direction) => moveItem("seriesIntl", index, direction)}
        addItem={(option) => addItem("seriesIntl", option)}
        removeItem={(id) => removeItem("seriesIntl", id)}
        saveIndividual={saveIndividual}
        showUpdateBtn={showUpdateBtn}
        typeId={13}
        type="Series (Intl):" 
        model={model} 
        availableItems={data} />
    );
};

export default SeriesInt;